<template>
  <v-btn  
    :color="color"
    flat
    @click.stop="deleteAction">
    <slot/>
  </v-btn>
</template>

<script>
// const debug = require('debug')('OD::Error')

export default {
  name: 'Error',
  props: {
    color: {
      type: String,
      default: 'error',
    },
    page: {
      type: String,
      required: true,
    },
    item: {
      type: Object,
      required: true,
    },
  },
  methods: {
    async deleteAction() {
      const result = await this.$swal({
        title: this.$t(`page.${this.page}.delete.title`),
        text: this.$t(`page.${this.page}.delete.text`),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        cancelButtonText: this.$t(`page.${this.page}.delete.cancelButtonText`),
        confirmButtonText: this.$t(`page.${this.page}.delete.confirmButtonText`),
      })
      // debug('result', result)
      if (result) {
        this.$emit('onDelete', this.item)
        this.$swal({
          title: this.$t(`page.${this.page}.delete.confirm.title`),
          text: this.$t(`page.${this.page}.delete.confirm.text`),
          type: 'success',
          showConfirmButton: false,
          timer: 1500,
        })
      }
    },
  },
}
</script>

<style>

</style>
